import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "../../../api";
import toastMessages from "../../helpers/toastMessage";
import { useOktaAuth } from "@okta/okta-react";
import { AxiosError } from "axios";

function useDisassociateLabel(setRemoving: (value: boolean) => void, row: any) {
  const authState = useOktaAuth()?.authState;
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["disassociateLabel"],
    mutationFn: (values: any) => {
      const orderId = row.original.id;
      const fedexLabelId = row.original.fedexLabelId;
      setRemoving(true);

      return axiosInstance.put(
        "/v1/orders/disassociate-label",
        {
          orderId,
          fedexLabelId,
        },
        {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        }
      );
    },
    onSuccess: (response: any) => {
      const { statusCode } = response;

      toastMessages.success("Order removed!");

      queryClient.invalidateQueries({ queryKey: ["testOrdersList"] });

      setRemoving(false);
    },
    onError: (error: AxiosError<any, any>) => {
      toastMessages.error(error.message);
      setRemoving(false);
    },
  });
}

export default useDisassociateLabel;
